import request from '@/config/axios';

// 数字人 模型 VO
export interface AiAvatarVO {
  id: number; // 编号
  userId: number; // 用户id
  title: string; // 名称
  avatar: number; // 数字人标识
  status: number; // 状态
  publicStatus: boolean; // 公开状态
  applyPublish:boolean;// 申请发布状态
  videoUrl: string; // 视频地址
  errorMessage: string; // 错误信息
  taskId: number; // 任务编号
  createTime: Date; // 创建时间
  finishTime: Date; // 完成时间
}


export const AiAvatarApi = {
  // 获取分页
  getList: async (params: any) => {
    return await request.get({ url: `/ai/avatar/page`, params });
  },

  // 详情
  get: async (id: number) => {
    return await request.get({ url: `/ai/avatar/get?id=${id}`});
  },
  
  // 更新绘画发布状态
  update: async (data: any) => {
    return await request.put({ url: '/ai/avatar/update', data });
  },

  // 删除绘画
  delete: async (id: number) => {
    return await request.delete({ url: `/ai/avatar/delete?id=` + id });
  },

  // 发布 
  audits: async (data:{id:Number,publicStatus:Boolean}) => {
    return await request.post({ url: '/ai/avatar/audits-publish',data});
  },

  // 申请发布
  apply: async (data:{id:Number,applyPublish:Boolean}) => {
    return await request.post({ url: '/ai/avatar/apply-publish',data});
  },

  // =================   生成记录============================================
  // 获得所有生成记录分页

};
